var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("surveyCopy")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v(" " + _vm._s(_vm.$t("surveyName")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.name = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("surveyCopyTo")))]),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.accountsAvailableToShareWith,
                    reduce: e => e.dbId,
                    label: "text",
                    multiple: ""
                  },
                  model: {
                    value: _vm.sharedWithAccounts,
                    callback: function($$v) {
                      _vm.sharedWithAccounts = $$v
                    },
                    expression: "sharedWithAccounts"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnCancel")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: !_vm.name.length },
                on: { click: _vm.copySurvey }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnCreate")) + "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }